var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"te-back-frame"},[_c('Menu'),_c('div',{staticClass:"te-main"},[_c('Header'),_c('div',{staticClass:"te-content"},[_c('router-view',{key:_vm.t,staticClass:"h-100",attrs:{"menu-feature":_vm.menuFeature}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }